// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.bs.mjs";

var SPDP = {};

function getStaticSPDP(identifier) {
  return LumiRequest.mapResponse(LumiRequest.expectJSONAsAny(LumiRequest.make("/green-mobility/spdp/v2/static/" + identifier, "GET", undefined, undefined, undefined)), (function (obj) {
                var pfi = obj.parkingFacilityInformation;
                return {
                        name: pfi.name,
                        url: pfi.operator.url,
                        addresses: pfi.accessPoints.map(function (obj) {
                              return obj.accessPointAddress;
                            })
                      };
              }));
}

function getDynamicSPDP(identifier) {
  return LumiRequest.mapResponse(LumiRequest.expectJSONAsAny(LumiRequest.make("/green-mobility/spdp/v1/dynamic/" + identifier, "GET", undefined, undefined, undefined)), (function (obj) {
                var pfdi = obj.parkingFacilityDynamicInformation;
                var status = pfdi.facilityActualStatus;
                return {
                        name: pfdi.name,
                        isOpen: status.open,
                        isFull: status.full,
                        capacity: status.parkingCapacity,
                        vacantSpaces: status.vacantSpaces,
                        description: pfdi.description
                      };
              }));
}

var API = {
  getStaticSPDP: getStaticSPDP,
  getDynamicSPDP: getDynamicSPDP
};

export {
  SPDP ,
  API ,
}
/* LumiRequest Not a pure module */
